import { schema } from 'normalizr'

export const customer_provider = new schema.Entity('providers', {

}, {
  idAttribute: 'uuid'
})